import styled from "styled-components";
import { useRef, useEffect } from "react";

const Textarea = styled.textarea(
  ({ theme, color, valid, variant, resize }) => ({
    fontSize: 14,
    color: color ? color : theme.color.navy,
    fontWeight: 400,
    letterSpacing: 0.32,
    borderRadius: 20,
    padding: "10px 20px 10px 20px",
    textAlign: "start",
    border: "none",
    width: "100%",
    height: 130,
    backgroundColor: "transparent",
    "::placeholder": {
      color: theme.color.gray70,
    },
    resize,
  })
);

const TextAreaContainer = styled.div``;

const Label = styled("div")(({ theme }) => ({
  fontSize: 14,
  color: theme.color.label,
  fontWeight: 400,
  letterSpacing: 0.32,
  textAlign: "start",
  lineHeight: "30px",
}));

const Error = styled("div")`
  margin-top: 1rem;
  font-size: 12px;
  color: red;
`;

const StyledDiv = styled.div(({ theme, variant, valid, color }) => ({
  borderRadius: 20,
  backgroundColor: variant === "outlined" ? theme.color.gray10 : "transparent",

  display: "flex",
  border:
    variant === "outlined"
      ? `1px solid  ${
          valid === false ? "red" : color ? color : theme.color.primary
        }`
      : "none",
}));

const TextArea = ({
  label,
  value,
  cols,
  rows,
  name,
  onChange,
  onBlur,
  placeholder,
  startImg,
  isRtl,
  helperText,
  variant,
  valid,
  divStyle,
  resize = "none",
  disabled,
  ...props
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto"; // Reset height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set to content height
    }
  }, [value]);

  return (
    <TextAreaContainer style={{ ...props.style }}>
      {!!label && <Label>{label}</Label>}
      <StyledDiv variant={variant} valid={valid} style={divStyle}>
        <Textarea
          ref={textareaRef}
          disabled={disabled}
          value={value}
          placeholder={placeholder}
          name={name}
          rows={rows}
          cols={cols}
          onChange={onChange}
          startImg={startImg}
          onBlur={onBlur}
          resize={resize}
        />
      </StyledDiv>
      {!!helperText && <Error>{helperText}</Error>}
    </TextAreaContainer>
  );
};

export default TextArea;
